import { useContext } from 'react';
import { AuthContext } from '../utils/firebase';

// ----------------------------------------------------------------------

const useAuth = () => useContext(AuthContext);

export default useAuth;
